import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { appCommonConstants } from '../../../../app.constants';
import { IEnvironment } from '../../../../interfaces/environment.interfaces';
import { animationEnabled } from '../../../../services/apphelper';
import { AppEventService } from '../../../../services/event.service';
import { AppVersionCheckService } from '../../../../services/versionCheck.service';

@Component({
  selector: 'app-ui-info',
  standalone: true,
  imports: [TranslateModule, CommonModule],
  template: `
    <div class="card card-body mb-0" style="height: 100%;">
      <div class="text-end">
        <div *ngIf="message" class="mb-2">
          <div class="alert alert-info" [innerHtml]="message"></div>
        </div>
        <p class="m-1">{{'MESSAGE.APPNAME'|translate}}:&nbsp;<b>{{ environment.appSettings.applicationName }}</b></p>
        <p class="m-1">{{'MESSAGE.APPTITLE'|translate}}:&nbsp;<b>{{ environment.appSettings.appTitle }}</b></p>
        <p class="m-1">{{'MESSAGE.APPVERSION'|translate}}:&nbsp;<b>{{ environment.appSettings.appVersion }}</b></p>
        <p class="m-1">{{'MESSAGE.NGVERSION'|translate}}:&nbsp;<b>{{ ngVersion }}</b></p>
        <button *ngIf="environment.versionCheck" class="btn btn-info mt-4" style="bottom: 1rem; position: absolute; right: 1rem;" (click)="versionCheck()"><i class="fas fa-search"></i>&nbsp;{{'MESSAGE.VERSION_CHECK.TITLE'|translate}}</button>
      </div>
      <div class="alert mt-2" [ngClass]="messageAnimationEnabled?'alert-info':'alert-warning'">
        {{messageAnimation|translate}}
      </div>
    </div>`,
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: '0' }),
        animate('.25s ease-out', style({ opacity: '1' })),
        transition(':leave', [
          style({ opacity: '1' }),
          animate('.25s ease-out', style({ opacity: '0' })),
        ]),
      ])
    ])
  ]
})

export class AppUiInfoComponent implements OnDestroy, OnInit {
  constructor(
    private appVersion: AppVersionCheckService,
    private eventService: AppEventService,
    private translate: TranslateService) { }

  ngOnDestroy() {
    // Unsubscribe from the event to prevent memory leaks
    this.subscription?.unsubscribe();
  }

  ngOnInit() {
    this.subscription = this.eventService.on(appCommonConstants.events.versionCheck).subscribe((message: any) => {
      this.message = this.translate.instant(message);
    });
  }

  public environment: IEnvironment = environment;
  public ngVersion: string = document.querySelector('body')!.getAttribute("ng-version")!;
  public message?: string;

  private subscription?: Subscription;

  public get messageAnimation(): string {
    if (this.messageAnimationEnabled) {
      return "MESSAGE.Animazioni abilitate normalmente";
    } else {
      return "MESSAGE.Animazioni ridotte o disabilitate dalle impostazioni di sistema";
    }
  }

  public get messageAnimationEnabled(): boolean {
    return animationEnabled();
  }

  public versionCheck(): void {
    this.message = undefined;
    this.appVersion.versionCheck(undefined, false);
  }
}
